// extracted by mini-css-extract-plugin
export default {"light":"400","normal":"500","bold":"600","bolder":"700"};